<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">短信通知（阿里云短信）</div>
      
      <el-form-item label="AccessKey">
        <el-input v-model="form.AccessKeyId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AccessKeySecret">
        <el-input v-model="form.AccessKeySecret" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="短信签名">
        <el-input v-model="form.sign" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">短信模板</div>
      <el-form-item label="注册短信模板">
        <el-input v-model="form.login_template" class="max-w460"></el-input>
        <div class="tips">
          不填则表示不支持h5登录
        </div>
      </el-form-item>
      <el-form-item label="商户申请短信模板">
        <el-input v-model="form.apply_template" class="max-w460"></el-input>
        <div class="tips">
          如果不开启手机验证可以不用填写
        </div>
      </el-form-item>
      <el-form-item label="商户审核未通过短信模板">
        <el-input v-model="form.supplier_reject_code" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户审核通过短信模板">
        <el-input v-model="form.supplier_pass_code" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="咨询提醒">
        <el-input v-model="form.consulting_template" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="活动推广">
        <el-input v-model="form.activity_template" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="客服电话">
        <el-input v-model="form.phone" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">短信宝</div>
      <el-form-item label="账号">
        <el-input v-model="form.username" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="签名">
        <el-input v-model="form.bao_sign" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        AccessKeyId: '',
        AccessKeySecret: '',
        sign: '',
        accept_phone: '',
        login_template: '',
        apply_template: '',
        supplier_reject_code: '',
        supplier_pass_code: '',
        consulting_template: '',
        activity_template: '',
        phone: '',
        username: '',
        password: '',
        bao_sign: '',
      },
      loading: false,
    };
  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.smsDetail({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          self.form.AccessKeyId = vars.engine.aliyun.AccessKeyId;
          self.form.AccessKeySecret = vars.engine.aliyun.AccessKeySecret;
          self.form.sign = vars.engine.aliyun.sign;
          self.form.accept_phone = vars.engine.aliyun.accept_phone;
          self.form.template_code = vars.engine.aliyun.template_code;
          self.form.login_template = vars.engine.aliyun.login_template;
          self.form.apply_template = vars.engine.aliyun.apply_template;
          self.form.supplier_reject_code = vars.engine.aliyun.supplier_reject_code;
          self.form.supplier_pass_code = vars.engine.aliyun.supplier_pass_code;
          self.form.consulting_template = vars.engine.aliyun.consulting_template;
          self.form.activity_template = vars.engine.aliyun.activity_template;
          self.form.phone = vars.engine.aliyun.phone;
          self.form.username = vars.engine.duanxinbao.username;
          self.form.password = vars.engine.duanxinbao.password;
          self.form.bao_sign = vars.engine.duanxinbao.bao_sign;
        })
        .catch(error => { });

    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editSms(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，短信通知设置成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    },
    //发送短信
    sendOut() {
      let self = this;
      let params = this.form;
      SettingApi.sendSms(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，短信发送成功',
            type: 'success'
          });
          self.$router.push('/setting/Sms');

        })
        .catch(error => {

        });
    }



  }

};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/sms/index.vue